import React from "react";
import { connect } from "react-redux";
import { EmployeeDetails } from "components/User";
import { MCard, MGridLayout, MSpinner } from "components/Shared";
import EmployeeMappings from "components/EmployeeCustomerSurveyTypes/EmployeeMappings";
import { EmployeeListDto } from "interfaces/Mueller.Business.Models";
import EmployeeTEAM from "components/Employee/EmployeeTEAM";
import { MANAGEMENT_CALENDAR_EDIT } from 'typeConstants/rights';
import { userHasRight } from "selectors/rights";
import EmployeeCalendar from "components/Employee/EmployeeCalendar.tsx";


interface Props {
  verticalDisplay: boolean,
  selectedUserIndex: number,
  // Redux
  fetchingSchedulingUsers: boolean,
  schedulingUsers: EmployeeListDto[],
  canEditCalendarAsManager: boolean,
};

const SchedulingAssistantProfile = (props: Props) => {
  if (props.fetchingSchedulingUsers) {
    return (<MSpinner/>);
  }

  const user = props.schedulingUsers[props.selectedUserIndex];

  const rows = [
    [
      { component: <EmployeeDetails employeeId={user.employeeId} /> },
      { component: <EmployeeTEAM internetUserId={user.internetUserId} overrideCellWidth /> },
      { component: <EmployeeMappings employeeId={user.employeeId} /> },
    ],
    [
      {
        component: (
          <MCard
            title="Employee Calendar"
            fields={[
              {
                key: "calendar", 
                control: (
                  <EmployeeCalendar 
                    employeeId={user.employeeId}
                    readOnly={!props.canEditCalendarAsManager}
                    allowManagementEdit={props.canEditCalendarAsManager}
                  />)
              }]}
          />
        ),
      },
    ],
  ];

  return (
    <MGridLayout
      rows={rows}
      verticalDisplay={props.verticalDisplay}
      padding={props.verticalDisplay ? 0 : 1}
    />
  );
};

const mapStateToProps = state => ({
  fetchingSchedulingUsers: state.employee.fetchingSchedulingUsers,
  schedulingUsers: state.employee.schedulingUsers,
  canEditCalendarAsManager: userHasRight(MANAGEMENT_CALENDAR_EDIT)(state),
});

export default connect(mapStateToProps)(SchedulingAssistantProfile);
